(() => {
  const body = document.body;
  if (!body) return;

  /* -------------------------------------------------------------------------
     PAGE DETECTION
     Replaces all Liquid template conditionals for JS behaviour.
  -------------------------------------------------------------------------- */
const path = window.location.pathname.toLowerCase();

const isMedicines     = path.includes('/pages/medicines');

const isMounjaro      =
  path === '/pages/mounjaro' ||
  path === '/pages/mounjaro/';

const isWegovy        =
  path === '/pages/wegovy' ||
  path === '/pages/wegovy/';

const isWegovyOral    =
  path === '/pages/wegovy-oral' ||
  path === '/pages/wegovy-oral/';

const isFoundayo      =
  path === '/pages/foundayo' ||
  path === '/pages/foundayo/';

const isRetatrutide   =
  path === '/pages/retatrutide' ||
  path === '/pages/retatrutide/';

const isContact       = path.includes('/pages/contact');

const isPharmacy      =
  path === '/pages/pharmacy-team' ||
  path === '/pages/pharmacy-team/';

const isAccount       = path.includes('/pages/account');

const hasScrollChrome =
  isMedicines ||
  isMounjaro ||
  isWegovy ||
  isWegovyOral ||
  isFoundayo ||
  isRetatrutide ||
  isContact ||
  isPharmacy;

  /* -------------------------------------------------------------------------
     ACCOUNT CLEAN UI
     Replaces: conditional account-chrome-hide.js load in theme.liquid
  -------------------------------------------------------------------------- */
  if (isAccount) {
    body.classList.add('account-clean-ui');
  }

  /* -------------------------------------------------------------------------
     PHARMACY HEADER FIX
     Replaces: conditional pharmacy-team-header-fix.js load in theme.liquid
  -------------------------------------------------------------------------- */
  if (isPharmacy) {
    const setSpacer = () => {
      const wrap   = document.getElementById('shopify-section-header');
      const header = document.querySelector('#shopify-section-header .header_main_area.mounjaro-header');
      if (!wrap || !header) return;

      const h = Math.ceil(header.getBoundingClientRect().height || 0);
      if (h > 0) {
        wrap.style.height     = h + 'px';
        wrap.style.minHeight  = h + 'px';
        wrap.style.overflow   = 'visible';
      }
    };

    window.addEventListener('DOMContentLoaded', setSpacer);
    window.addEventListener('load',             setSpacer);
    window.addEventListener('resize',           setSpacer);
    window.addEventListener('pageshow',         setSpacer); // handles back/forward cache
  }

  /* -------------------------------------------------------------------------
     UNIFIED SCROLL HIDE/SHOW SYSTEM
     Replaces: both inline scroll <script> blocks in theme.liquid
       - medicines scroll script  (used class: med-chrome-hidden)
       - mounjaro scroll script   (used class: mj-hidden)
     Now uses a single class `ui-hidden` on <body>.
     Your CSS should map:  body.ui-hidden .rot-ann,
                           body.ui-hidden .header_main_area  { ... }
  -------------------------------------------------------------------------- */
  if (!hasScrollChrome) return; // skip scroll wiring on pages that don't need it

  const THRESHOLD = 10;
  let lastY    = window.scrollY || 0;
  let ticking  = false;

  function setHidden(hide) {
    body.classList.toggle('ui-hidden', hide);
  }

  function onScroll() {
    const y     = window.scrollY || 0;
    const delta = y - lastY;

    if (y <= 0) {
      setHidden(false);
    } else if (delta > THRESHOLD) {
      setHidden(true);
    } else if (delta < -THRESHOLD) {
      setHidden(false);
    }

    lastY   = y;
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(onScroll);
    },
    { passive: true }
  );

  // Run once on load so initial scroll position is respected
  window.addEventListener('load', () => requestAnimationFrame(onScroll));

  // Re-run after Shopify sections inject dynamically (theme editor)
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(onScroll));

})(); // ← single, correct IIFE close